/**
 * Utilidades para depuración
 */

/**
 * Registra información detallada sobre un error de Axios
 * @param {Error} error - Error de Axios
 * @param {string} context - Contexto en el que ocurrió el error
 */
export const logAxiosError = (error, context = 'Error') => {
  console.error(`${context}:`, error);
  
  if (error.response) {
    // El servidor respondió con un código de estado fuera del rango 2xx
    console.error('Datos del servidor:', error.response.data);
    console.error('Código de estado:', error.response.status);
    console.error('Cabeceras:', error.response.headers);
  } else if (error.request) {
    // La solicitud se realizó pero no se recibió respuesta
    console.error('No hubo respuesta del servidor. Solicitud:', error.request);
  } else {
    // Algo sucedió al configurar la solicitud
    console.error('Error al configurar la solicitud:', error.message);
  }
  
  // Si hay detalle sobre la configuración
  if (error.config) {
    console.error('Configuración de la solicitud:', {
      url: error.config.url,
      method: error.config.method,
      headers: error.config.headers,
      data: JSON.parse(error.config.data || '{}')
    });
  }
  
  console.error('Stack trace:', error.stack);
};

/**
 * Valida los datos de una receta médica
 * @param {Object} recetaData - Datos de la receta
 * @returns {Object} - Objeto con validación y mensajes de error
 */
export const validarRecetaMedica = (recetaData) => {
  const errores = [];
  
  // Verificar estructura básica
  if (!recetaData) {
    errores.push('No se proporcionaron datos de receta');
    return { valido: false, errores };
  }
  
  // Verificar medicamentos
  if (!recetaData.medicamentos || !Array.isArray(recetaData.medicamentos) || recetaData.medicamentos.length === 0) {
    errores.push('Se debe proporcionar al menos un medicamento');
  } else {
    // Verificar cada medicamento
    recetaData.medicamentos.forEach((med, index) => {
      if (!med.nombre) {
        errores.push(`Medicamento ${index + 1}: Falta el nombre`);
      }
      if (!med.dosis) {
        errores.push(`Medicamento ${index + 1}: Falta la dosis`);
      }
      if (med.duracion !== null && med.duracion !== undefined) {
        const duracion = parseInt(med.duracion, 10);
        if (isNaN(duracion)) {
          errores.push(`Medicamento ${index + 1}: La duración debe ser un número`);
        }
      }
    });
  }
  
  return {
    valido: errores.length === 0,
    errores
  };
};